<template>
    <div class="contact-container">
        <PageTitle :title="title"></PageTitle>

        
            <p class="light text-contact">Vous souhaitez obtenir des renseignements sur nos solutions Web, nos options et nos services ?<br />
            Vous avez besoin d’un devis pour l’un de vos projets ?<br />
            Contactez-nous !</p>


            <form class="contact-form">                 

                <div class="form-row">
                    <div class="form-col">
                        <input type="text" name="nom" :class="['nom', 'input-required', nomRequired ? 'input-error' : '']" @keyup="removeNom" placeholder="Nom *" v-model="nom" />
                    </div>
                    <div class="form-col">
                        <input type="text" name="societe" class="societe" v-model="societe"  placeholder="Société" />
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-col">
                        <input type="email" name="mail" :class="['mail', 'input-required', mailRequired ? 'input-error' : '']" @keyup="removeMail" v-model="email"  placeholder="Email *" />
                    </div>
                    <div class="form-col">
                        <input type="text" name="fonction" class="fonction" v-model="fonction"  placeholder="Fonction" />
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-col">
                        <input type="tel" name="tel" :class="['tel', 'input-required', telRequired ? 'input-error' : '']" placeholder="Téléphone *" @keyup="removeTel" v-model="tel"  />
                    </div>
                    <div class="form-col">
                        <input type="text" name="sujet" class="sujet" v-model="sujet"  placeholder="Sujet" />
                    </div>
                </div>

                <div class="form-row">
                    <textarea name="message" rows="10" :class="['message', 'input-required', messageRequired ? 'input-error' : '']" v-model="message" @keyup="removeMessage"   placeholder="Message *"></textarea>
                </div>

                <div :class="[ 'form-row', 'rgpd', rgpdRequired ? 'rgpd-error' : '']">
                    <input type="checkbox" name="rgpd" @click="removeRGPD"  v-model="rgpd" /><div class="rgpd-text">En soumettant ce formulaire j’accepte que les informations saisies soient exploitées par le service client SYNTHES'3D dans le cadre de ma demande et de la relation commerciale qui peut en découler.</div>
                </div>

                <vue-recaptcha sitekey="6Lfqh7oUAAAAABtmQqjbl0R_-X7Q8jK8AD_BHjZc" :loadRecaptchaScript="true"></vue-recaptcha>

                <div class="form-row">
                    <input type="submit" class="btn-main" value="Envoyer" @click="sendEmail($event)"/>
                </div>

                <div v-if="errors" class="errors">
                    Le formulaire n'a pas pu être envoyé.
                </div>

                <div v-if="succes" class="succes">
                    Votre message a bien été envoyé.<br /> Nous vous recontacterons très prochaiement.
                </div>
           
        </form>
<!-- 
        <div class="contact-infos">
            <div class="contact-item">
                <img src="./../../assets/contact-icone-phone.png" alt="phone" />
                <p class="regular contact-icone">04 86 31 53 84</p>
            </div>
            <div class="contact-item">
                <img src="./../../assets/contact-icone-email.png" alt="email" />
                <a class=" contact-icone regular" href="mailto:contact@synthes3dweb.com">contact@synthes3dweb.com</a>
            </div>
        </div> -->
        <div class="section-last"></div>
    </div>
</template>

<script>

import PageTitle from "./../layout/PageTitle";
import VueRecaptcha from 'vue-recaptcha';
import axios from 'axios'

export default {
    name: 'Contact',
    props:  {
        title: {
            type : String,
            default: 'Contact'
        }
    },
    components : {
        PageTitle, VueRecaptcha 
    },
    data() {
        return {
            nom :'',
            fonction :'',
            societe :'',
            email: '',
            tel : '',
            sujet : '',
            message : '',
            rgpd : false,
            errors : false,
            succes : false,
            nomRequired : false,
            telRequired : false,
            mailRequired : false,
            messageRequired : false,
            rgpdRequired : false       
        }
    },
    methods : {
        sendEmail(e){
            e.preventDefault()
            this.errors = false
            this.succes = false
            this.nomRequired = false
            this.telRequired = false
            this.mailRequired = false
            this.messageRequired = false
            this.rgpdRequired = false  

            if(this.nom.length < 1 ) {
                this.errors  = true
                this.nomRequired = true
            }

            if(this.email.length < 1 ) {
                this.errors  = true
                this.mailRequired = true
            }

            if(this.tel.length < 1 ) {
                this.errors  = true
                this.telRequired = true
            }

            if(this.message.length < 1 ) {
                this.errors  = true
                this.messageRequired = true
            }

            if(!this.rgpd ) {
                this.errors  = true
                this.rgpdRequired = true
            }


            if(!this.errors) {
                this.succes = true
                axios.post(
                        "https://www.synthes3dweb.com/mailer/sendmail.php",
                        {
                            nom : this.nom,
                            email : this.email,
                            rgpd  : this.rgpd,
                            tel : this.tel,
                            message : this.message,
                            societe : this.societe,
                            sujet : this.sujet,
                            fonction : this.fonction
                        }
                    )
                    .then(res => {
                        if (res == 'ok') {
                            this.succes  = true
                        } else {
                            this.echec  = true
                        }
                    });
            }
        },
        removeNom() {
            this.nomRequired = false;
        },
        removeMail() {
            this.mailRequired = false;
        },
        removeTel() {
            this.telRequired = false;
        },
        removeMessage() {
            this.messageRequired = false;
        },
        removeRGPD() {
            this.rgpdRequired  =false;
        }
    }
 
}
</script>

<style scoped>
    .contact-container {
        background: url('./../../assets/bg-contact.jpg');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        margin-top:-100px;
    }

    .contact-form {
        margin:80px auto;
        width:100%;
        max-width:620px;
    }

    .text-contact {
        color:#ffffff;
        margin-top:80px;
    }

    .form-row {
        display:flex;  
        margin-bottom:15px;      
    }

    .form-col {
        width:50%;
        display: flex;
        justify-content: center;
    }

    input[type="text"], input[type="email"], input[type="tel"] {
        width:calc(100% - 50px);
        padding:10px 15px;
        border-radius:15px;
        border: none;
        color:#1a1a1a;
        border:1px solid transparent;
        font-family: 'Montserrat';
    }

    input[type="checkbox"] {
        margin-left:10px;
    }

    .rgpd-text {
        font-size:12px;
        color:#fff;
    }

    input[type="text"]:focus, input[type="mail"]:focus, input[type="tel"]:focus {
        border:1px solid #f78c37;
    }

    input[type="submit"] {
        border: none;
        margin:20px auto 0;
        padding: 10px 25px 10px 25px;
    }

    input:focus {
        outline: none;
    }

    textarea {
        width:calc(100% - 50px);
        padding:10px 15px;
        border-radius:15px;
        border: none;
        color:#1a1a1a;
        margin:0 auto;
        border:1px solid transparent;
        font-family: 'Montserrat';
    }

    textarea:focus {
        outline: none;
        border:1px solid #f78c37;
    }

    ::-webkit-input-placeholder {
        font-style: italic;
    }

    :-moz-placeholder {
        font-style: italic;  
    }

    ::-moz-placeholder {
        font-style: italic;  
    }

    :-ms-input-placeholder {  
        font-style: italic; 
    }

    .contact-infos {
        display: flex;
        width:100%;
        max-width:900px;
        margin:0 auto;
    }

    .contact-item {
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex: 1 1 0;
    }

    .contact-item img {
        margin-bottom : 20px;
    } 

    .contact-icone {
        color:#ffffff;
        font-size:20px;
        letter-spacing: 5px;
    }

    a.contact-icone {
        text-decoration: none;
    }

    a.contact-icone:hover {
        color:#f78c37;
    }

    .errors {
        padding:20px;
        text-align: center;
        color:#f78c37;
        font-weight:bold;
    }

    .succes {
        padding:20px;     
        text-align: center;
        color:#92cd6b;
        font-weight:bold;
    }

    .input-error {
        border:1px solid red !important;
    }

    .rgpd-error {
        border:1px solid red !important;
    }

    .rgpd {
         border:1px solid transparent;
    }

    @media screen and (max-width: 767px) {
        .contact-infos {
            flex-direction: column;
        }

        .contact-icone {
            font-size:15px;
            letter-spacing: 2px;
            margin:0 0 20px 0;
        }

        .contact-container {
            margin-top: -260px;
            padding-top:62px;
            background: url('./../../assets/bg-contact-mobile.jpg');
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
        }

        .text-contact {
            padding:0 20px;
            margin-top:40px;
        }

        .contact-form {
            margin-top:40px;
        }

        .form-row {
            flex-direction: column;
            margin-bottom:0;
        }

        .form-row.rgpd {
            flex-direction: row;
            margin-bottom: 15px;
            margin-top:15px;           
        }

        .form-col {
            width:100%;
            margin-bottom:15px;
        }
    }

</style>